export enum Role {
  Admin = 'Admin',
  User = 'User',
  user = 'user',
  admin = 'admin',
  superadmin = 'superadmin'
}
